import AnalyticsListener from './AnalyticsListener';

export default AnalyticsListener;
